module.exports = "<div class=\"header-titles flex\"> {{#each headList}} <div class=date-head> <span>{{this}}</span> </div> {{/each}} </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/bisystem/canvas/main/cells/cell/calendar/calendar.small/calendar.small.header/calendar.small.header.html
// module id = 4913
// module chunks = 50